module.exports = __webpack_public_path__ + "static/img/IMG_20160307_125908.5d11e77c.jpg";